import { createContext, useContext } from "react";

interface RouterValue {
  navigate: (to: string) => void;
  params: Record<string, string>;
}

export const RouterCtx = createContext<RouterValue>({
  navigate: () => {},
  params: {},
});

export function useNavigate() {
  return useContext(RouterCtx).navigate;
}

export function useParams() {
  return useContext(RouterCtx).params;
}
